export default {
  workApprovalWorks: [],
  workApprovalProductions: [],
};
